"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosClientEventEmitter = exports.AxiosClientEvent = void 0;
const GatherEventEmitter_1 = require("gather-common-including-video/dist/src/public/GatherEventEmitter");
var AxiosClientEvent;
(function (AxiosClientEvent) {
    AxiosClientEvent["SSOAuthenticationFailed"] = "SSOAuthenticationFailed";
})(AxiosClientEvent || (exports.AxiosClientEvent = AxiosClientEvent = {}));
exports.axiosClientEventEmitter = new GatherEventEmitter_1.GatherEventEmitter();
//# sourceMappingURL=axiosClientEventEmitter.js.map